// Package imports:
import React from 'react';
// Component imports:
import ChatBotComp from '../../ui-elements/ChatBot/ChatBot';

const ChatBot: React.FC = () => {
    return (
        <ChatBotComp />
    );
}

export default ChatBot;